// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pl_a bhl_ea bhl_ke bhl_ju bhl_a bhl_j bhl_so bhl_sp","SearchPanel__icon":"pl_b bhl_vo bhl_hi bhl_su bhl_va","SearchPanel__input":"pl_c bhl_jb bhl_eg bhl_z"};